import { IApplicationState } from '../../types/redux';
import { ENewReviewModalStep } from '../../types/newReview';
import { getIsAgent } from '../user';

export const getIsNextStepAvailable = (state: IApplicationState): boolean => {
  const isAgent = getIsAgent(state);
  if (state.newReview.meta.step === ENewReviewModalStep.Rating) {
    const { transportRating, ecologyRating, generalRating, infrastructureRating, priceAndQualityBalanceRating } =
      state.newReview.data;

    return Boolean(
      !isAgent &&
        transportRating.value &&
        ecologyRating.value &&
        generalRating.value &&
        infrastructureRating.value &&
        priceAndQualityBalanceRating.value,
    );
  }

  if (state.newReview.meta.step === ENewReviewModalStep.Review) {
    const { pros, cons, userStatus } = state.newReview.data;

    return Boolean((pros.value || cons.value) && userStatus.value && !isAgent);
  }

  return false;
};
